import axios from "axios";
import store from "./store/";

class api {
  constructor() {
    // this.baseUrl = store.getters.url.baseUrl;
    // this.grant_type = store.getters.url.grant_type;
    // this.client_id = store.getters.url.client_id;
    // this.client_secret = store.getters.url.client_secret;
    this.baseUrl = process.env.VUE_APP_BACKEND_URL;
    this.grant_type = process.env.VUE_APP_GRANT_TYPE;
    this.client_id = process.env.VUE_APP_CLIENT_ID;
    this.client_secret = process.env.VUE_APP_CLIENT_SECRET;
  }

  /**
   * GET Method
   * @param {string} url This is the API URL
   * @param {object} objectParam This is the parameters to be pass.
   * @param { string } type This is the parameters to be pass.
   *
   * @return {Promise}
   */
  async get(url, objectParam, type = "data") {
    if (!store.getters["auth/token"]) return false;

    let params = { ...objectParam };
    let req_params = { params: params, crossDomain: true };

    if (type == "blob") {
      req_params.responseType = "blob";
    }
    axios.defaults.headers.common[
      "Authorization"
    ] = `${store.getters["auth/token"].token_type} ${store.getters["auth/token"].access_token}`;

    var req_url = new URL(url, this.baseUrl);
    return await axios.get(req_url.href, req_params).then(function(response) {
      return response;
    });
  }

  /**
   * POST Method
   * @param {string} url This is the API URL
   * @param {object} objectParam This is the parameters to be pass.
   *
   * @return {Promise}
   */
  async post(url, objectParam, type = "data") {
    if (!store.getters["auth/token"]) return false;

    let clientKey = {
      client_id: this.client_id,
      client_secret: this.client_secret,
      grant_type: this.grant_type
    };
    clientKey = type == "login" ? clientKey : {};
    let params = new URLSearchParams(
      Object.entries({ ...clientKey, ...objectParam })
    );
    let content_type = {
      data: "application/x-www-form-urlencoded",
      login: "application/x-www-form-urlencoded",
      json: "application/json",
      file: "multipart/form-data",
      payment2: "application/json"
    };
    let add_header =
      type == "payment" || type == "payment2"
        ? { "X-Requested-With": "XMLHttpRequest" }
        : {};

    return await axios({
      method: "post",
      url:
        type == "payment" || type == "payment2"
          ? store.getters.url.ePaymentUrl + url
          : new URL(url, this.baseUrl),
      crossDomain: true,
      data:
        type == "json" ||
        type == "file" ||
        type == "payment" ||
        type == "payment2"
          ? objectParam
          : params,
      headers: {
        "Content-Type": content_type[type],
        Authorization: `${store.getters["auth/token"].token_type} ${store.getters["auth/token"].access_token}`,
        ...add_header
      }
    }).then(function(response) {
      return response;
    });
  }

  async put(url, objectParam, type = "data") {
    if (!store.getters["auth/token"]) return false;

    let clientKey = {
      client_id: this.client_id,
      client_secret: this.client_secret,
      grant_type: this.grant_type
    };
    clientKey = type == "login" ? clientKey : {};
    let params = new URLSearchParams(
      Object.entries({ ...clientKey, ...objectParam })
    );
    let content_type = {
      data: "application/x-www-form-urlencoded",
      login: "application/x-www-form-urlencoded",
      json: "application/json",
      file: "multipart/form-data",
      payment2: "application/json"
    };
    let add_header =
      type == "payment" || type == "payment2"
        ? { "X-Requested-With": "XMLHttpRequest" }
        : {};

    return await axios({
      method: "put",
      url: new URL(url, this.baseUrl),
      crossDomain: true,
      data:
        type == "json" ||
        type == "file" ||
        type == "payment" ||
        type == "payment2"
          ? objectParam
          : params,
      headers: {
        "Content-Type": content_type[type],
        Authorization: `${store.getters["auth/token"].token_type} ${store.getters["auth/token"].access_token}`,
        ...add_header
      }
    }).then(function(response) {
      return response;
    });
  }

  // async put(url, objectParam) {
  //   // axios.defaults.headers.common["Content-Type"] =
  //   //   "application/x-www-form-urlencoded";
  //   // axios.defaults.headers.common[
  //   //   "Authorization"
  //   // ] = `${store.getters["auth/token"].token_type} ${store.getters["auth/token"].access_token}`;
  //   let content_type = {
  //     data: "application/x-www-form-urlencoded",
  //     login: "application/x-www-form-urlencoded",
  //     json: "application/json",
  //     file: "multipart/form-data",
  //     payment2: "application/json"
  //   };
  //   var config = {
  //     headers: {
  //       "Content-Type": content_type["data"],
  //       Authorization: `${store.getters["auth/token"].token_type} ${store.getters["auth/token"].access_token}`,
  //       ...add_header
  //     },
  //     data: objectParam
  //   };
  //   return await axios
  //     .put(new URL(url, this.baseUrl), config)
  //     .then(function(response) {
  //       return response;
  //     });
  // }

  /** DELETE METHOD
   */
  async delete(url, objectParam) {
    // loadProgressBar();
    store.dispatch("setLoading", true);
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + store.getters.token;
    return await axios
      .delete(this.baseUrl + url, { params: objectParam, crossDomain: true })
      .then(function(response) {
        store.dispatch("setLoading", false);
        return response;
      });
  }

  async download(url, reportInfo, params) {
    var result = await this.get(url, params, "blob").then(data => {
      let download = {
        name: reportInfo.name || `download`,
        ext: reportInfo.ext || ".csv"
      };
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", download.name + download.ext);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    });
    return result;
  }
}

export default new api();
